module.exports = __webpack_public_path__ + "img/elastic length.afd16c5f.png";